import { Col, Row } from 'antd';
import { FieldInputProps, FieldMetaProps } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import CustomTextField from '~/components/fields/CustomTextField/CustomTextField';
import { creditCardDetails } from '~/utils/credit-card-details';
import { formatCardNumber, formatExpiryDate } from '~/utils/handle-input-events';

import styles from './PaymentMethodForm.module.scss';

export interface PaymentMethodFormProps {
  getFieldProps: (name: string) => FieldInputProps<any>;
  getFieldMeta: (name: string) => FieldMetaProps<any>;
  handleChange: (e: React.ChangeEvent<any>) => void;
  cardNumber: string;
  cardIcons?: React.ReactNode[];
}

const PaymentMethodForm: React.FC<PaymentMethodFormProps> = ({
  getFieldMeta,
  getFieldProps,
  handleChange,
  cardNumber,
  cardIcons,
}) => {
  const { maxLength: cardNumberMaxLength, cvvLength } = creditCardDetails(cardNumber);
  const { t } = useTranslation();
  return (
    <div>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderField}>
          <CustomTextField
            name="cardHolder"
            type="text"
            label={t('checkoutPage:nameOnCard')}
            placeholder="Name"
            meta={getFieldMeta('cardHolder')}
            field={getFieldProps('cardHolder')}
            onChange={handleChange}
          />
        </div>
        {cardIcons && cardIcons.length > 0 && (
          <div className={styles.cardIcons}>
            {cardIcons.map((icon, i) => (
              <span key={i}>{icon}</span>
            ))}
          </div>
        )}
      </div>
      <CustomTextField
        name="cardNumber"
        type="text"
        label={t('checkoutPage:cardNumber')}
        placeholder="XXXX XXXX XXXX XXXX"
        meta={getFieldMeta('cardNumber')}
        field={getFieldProps('cardNumber')}
        onChange={e => {
          formatCardNumber(e);
          handleChange(e);
        }}
        maxLength={cardNumberMaxLength}
        inputMode="numeric"
      />
      <Row gutter={[30, 30]}>
        <Col span={24} md={12}>
          <CustomTextField
            name="expirationDate"
            type="text"
            label={t('checkoutPage:expirationDate')}
            placeholder="MM/YY"
            meta={getFieldMeta('expirationDate')}
            field={getFieldProps('expirationDate')}
            onChange={e => {
              formatExpiryDate(e);
              handleChange(e);
            }}
            inputMode="numeric"
          />
        </Col>
        <Col span={24} md={12}>
          <CustomTextField
            name="cvv"
            type="text"
            label={t('checkoutPage:cvv')}
            placeholder="123"
            meta={getFieldMeta('cvv')}
            field={getFieldProps('cvv')}
            onChange={handleChange}
            inputMode="numeric"
            maxLength={cvvLength}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PaymentMethodForm;
